import ReactComponentMounter from '../utils/react-component-mounter';

import SegmentDetailsSideBar from '../apps/segments/SegmentDetailsSideBar';

ReactComponentMounter.register({
  SegmentDetailsSideBar
});
